$(function () {
	let Load		=	new XMLHttpRequest();
	let Map			=	{};
	let Markers		=	[];
	const $form		=	$("form.search");
	let selects		=	{};
	let data		=	{};
	let first		=	true;

	if($form.length != 0) {
		selects	=	{
			city	:	$form.find("select[name="+ Common.escapeSelector("cities[]") +"]"),
			group	:	$form.find("select[name="+ Common.escapeSelector("groups[]") +"]"),
			line	:	$form.find("select[name="+ Common.escapeSelector("lines[]") +"]")
		};
		data	=	{
			cities	:	JSON.parse($form.find(".data[data-name=cities]").attr("data-value")),
			groups	:	JSON.parse($form.find(".data[data-name=groups]").attr("data-value")),
			lines	:	JSON.parse($form.find(".data[data-name=lines]").attr("data-value")),
		};
	}

	/**************/
	/* 選択肢連動 */
	/**************/
	$("form.search select[name="+ Common.escapeSelector("groups[]") +"]").on("change", function (e) {
		const $target	=	$(this);
		const $form		=	$target.closest("form");
		let groups		=	$target.val();
		let pref		=	$("form.search select[name="+ Common.escapeSelector("prefs[]") +"]").val();

		if(typeof groups != "object") {
			groups	=	[groups];
		}

		if(groups.join("") == "") {
			$.each(["line"], function () {
				let $select	=	selects[this];

				$select.empty().removeAttr("disabled").append('<option value="">'+ $select.attr("data-placeholder") +'</option>');
				$select.append('<option value="" disabled>鉄道会社を選択してください</option>');
			});

			return;
		}

		$select	=	selects.line;
		$select.empty().removeAttr("disabled").append('<option value="">'+ $select.attr("data-placeholder") +'</option>');

		$.each(groups, function (key, group) {
			$.each(data.lines["a"+ group]["a"+ pref], function (key, line) {
				if(line.groupID == group) {
					$select.append('<option value="'+ line.lineID +'">'+ line.name +'</option>');
				}
			});
		});

		$select.trigger("change");
	});

	$("form.search select[name="+ Common.escapeSelector("prefs[]") +"]").on("change", function (e) {
		const $target	=	$(this);
		let prefs		=	$target.val();

		if(typeof prefs != "object") {
			prefs	=	[prefs];
		}

		if(prefs.join("") == "") {
			$.each(["city", "group"], function () {
				let $select	=	selects[this];

				$select.empty().removeAttr("disabled").append('<option value="">'+ $select.attr("data-placeholder") +'</option>');
				$select.append('<option value="" disabled>都道府県を選択してください</option>');
				$select.trigger("change");
			});

			return;
		}

		$select	=	selects.city;
		$select.empty().removeAttr("disabled").append('<option value="">'+ $select.attr("data-placeholder") +'</option>');

		$.each(prefs, function (key, pref) {
			$.each(data.cities[pref], function (key, city) {
				if(city.prefID == pref) {
					$select.append('<option value="'+ city.id +'">'+ city.name +'</option>');
				}
			});
		});

		$select.trigger("change");

		$select	=	selects.group;
		$select.empty().removeAttr("disabled").append('<option value="">'+ $select.attr("data-placeholder") +'</option>');

		$.each(prefs, function (key, pref) {
			let results	=	{};

			$.each(data.groups["a"+ pref], function (key, group) {
				if(group.prefID == pref) {
					results["a"+ group.groupID]	=	group;
				}
			});

			$.each(results, function (key, group) {
				$select.append('<option value="'+ group.groupID +'">'+ group.groupName +'</option>');
			});
		});

		$select.trigger("change");
	}).trigger("change");

	/********/
	/* 検索 */
	/********/
	$("form.search").find("select, input[type=checkbox]").on("change", function (e) {
		const $target	=	$(this);
		const $form		=	$("form.search");
		let data		=	$form.serialize().replace(/[a-z]+%5B%5D=&/g, "").replace(/[a-z]+%5B%5D=$/g, "");

		Load.abort();
		Load	=	$.ajax({
			url		:	$form.attr("action").replace(/\/load/g, "/preload"),
			type	:	"post",
			data	:	data,
		}).done(function (results) {
			for(let key in results.data.counts) {
				if(key == "types") {
					$(".counts .count[data-category="+ key +"]").text("(0)");

					for(let subKey in results.data.counts[key]) {
						$(".counts .count[data-category="+ key +"][data-type="+ subKey +"]").text("("+ results.data.counts[key][subKey] +")");
					}
				}
				else {
					let $options	=	$("select[name="+ Common.escapeSelector(key +"[]") +"] option[value!=\"\"]");

					$options.each(function () {
						let $option	=	$(this);

						if(!$option.is(":selected")) {
							$option.text($option.text().replace(/(\(\d+\))?$/, "(0)"));
						}
						else {
							$option.text($option.text().replace(/(\(\d+\))?$/, ""));
						}
					});

					for(let subKey in results.data.counts[key]) {
						let $option	=	$("select[name="+ Common.escapeSelector(key +"[]") +"] option[value="+ Common.escapeSelector(subKey) +"]");

						$option.text($option.text().replace(/\(\d+\)$/, "("+ results.data.counts[key][subKey] +")"));
					}

					$("select[name="+ Common.escapeSelector(key +"[]") +"] option[value*="+ Common.escapeSelector(",") +"]").each(function () {
						let $option	=	$(this);
						let cities	=	$option.val().split(",");
						let total	=	0;

						for(let city of cities) {
							total	+=	results.data.counts["cities"][city] || 0;
						}

						$option.text($option.text().replace(/\(\d+\)$/, "("+ total +")"));
					});
				}
			}
		});
	}).filter(":first").trigger("change");

	$("#MainSearch").on("click load", function (e) {
		const $target	=	$(this);
		const $form		=	$("form.search");
		let data		=	$form.serialize().replace(/[a-z]+%5B%5D=&/g, "").replace(/[a-z]+%5B%5D=$/g, "");

		$target.closest(".searchbutton").addClass("active");

		if($("#ListResult").length == 0) {
			location.href	=	BasePath +"/article/search?"+ data
			return;
		}

		Load.abort();
		Load	=	$.ajax({
			url		:	$form.attr("action"),
			type	:	"post",
			data	:	data,
		}).done(function (results) {
			searchMap(results, data);

			if(e.type == "click") {
				history.pushState({}, null, "?"+ data.replace(/_token=.*?&/, "").replace(/limit=.*?&/, ""));
			}
		}).always(function () {
			$target.closest(".searchbutton").removeClass("active");
		});
	});

	$("#NameSearch").on("click load", function (e) {
		e.preventDefault();
		const $target	=	$(this);
		const $form		=	$target.closest("form");
		let data		=	$form.serialize();

		$target.closest(".searchbutton").addClass("active");

		if($("#ListResult").length == 0) {
			location.href	=	BasePath +"/article/search?"+ data
			return;
		}

		Load.abort();
		Load	=	$.ajax({
			url		:	$form.attr("action"),
			type	:	"post",
			data	:	data,
		}).done(function (results) {
			searchMap(results, data);

			if(e.type == "click") {
				history.pushState({}, null, "?"+ data.replace(/_token=.*?&/, "").replace(/limit=.*?&/, ""));
			}
		}).always(function () {
			$target.closest(".searchbutton").removeClass("active");
		});
	});

	$("#SwitchList").on("click", function () {
		$("#Maps").fadeOut(function () {
			history.pushState({}, null, BasePath +"/article/search/list"+ location.search);

			$("#List").fadeIn();
		});
	});

	$("#SwitchMaps").on("click", function () {
		$("#List").fadeOut(function () {
			history.pushState({}, null, BasePath +"/article/search/maps"+ location.search);

			$("#Maps").fadeIn();
		});
	});

	$(".pager").on("click", "a", function (e) {
		e.preventDefault();
	});

	$(".externalLink").off("click").on("click", function (e) {
		e.preventDefault();

		$(".overlay").stop().fadeIn().css({display: "flex"});
	});

	$(".overlay .close").on("click", function (e) {
		e.preventDefault();

		$(".overlay").stop().fadeOut();
	});

	$("#ListNoticeMail, #MapNoticeMail").on("click", function (e) {
		e.preventDefault();

		window.open(BasePath +"/member/notice/add"+ location.search, "_blank");
	});

	function searchMap(results, data) {
		let bounds	=	new google.maps.LatLngBounds();

		$("#MapsResult").show();

		for(marker of Markers) {
			marker.setMap(null);
		}

		for(let article of results.data.articles) {
			if(!article.latitude || !article.longitude) {
				continue;
			}

			let position	=	new google.maps.LatLng(article.latitude, article.longitude);

			let marker	=	new google.maps.Marker({
				map			:	Map,
				position	:	position,
				icon		:	BasePath +"/assets/img/general/marker_"+ article.type +".png",
			});

			Markers.push(marker);
			google.maps.event.addListener(marker, 'click', function () {
				location.href	=	article.url;
			});

			bounds.extend(position);
		}

		if($("#List").is(":visible")) {
			$("#Maps").show();
		}

		Map.setOptions({
			maxZoom		:	18,
		});

		Map.fitBounds(bounds);

		Map.setOptions({
			maxZoom		:	21,
		});

		if($("#List").is(":visible")) {
			$("#Maps").hide();
		}

		$("#MapsCount").text(results.data.counts.total +"件見つかりました。（マンション："+ results.data.counts.mansion +"件、戸建："+ results.data.counts.house +"件、土地："+ results.data.counts.land +"件）")
		$("#ListCount").text(results.data.counts.total +"件見つかりました。");

		$("select[name=order]").off("change").on("change", function () {
			let sort		=	$("select[name=order]").val();
			let articles	=	results.data.articles;

			$("#List .nothing, #Maps .nothing").hide();
			$("#ListResult ul").empty();

			articles.sort(function(a, b) {
				if(sort.indexOf("Min") != -1) {
					if(parseFloat(a[sort]) == parseFloat(b[sort])) {
						return (parseInt(a.id) < parseInt(b.id))?	1	:	-1;
					}

					return (parseFloat(a[sort]) > parseFloat(b[sort]))?	1	:	-1;
				}
				else if(sort.indexOf("Max") != -1) {
					if(parseFloat(a[sort]) == parseFloat(b[sort])) {
						return (parseInt(a.id) < parseInt(b.id))?	1	:	-1;
					}

					return (parseFloat(a[sort]) < parseFloat(b[sort]))?	1	:	-1;
				}
				else if(sort.indexOf("Fast") != -1) {
					if(new Date(a[sort]).getTime() == new Date(b[sort]).getTime()) {
						return (parseFloat(a.id) > parseFloat(b.id))?	1	:	-1;
					}

					return (new Date(a[sort]).getTime() > new Date(b[sort]).getTime())?	1	:	-1;
				}
				else if(sort.indexOf("Late") != -1) {
					if(new Date(a[sort]).getTime() == new Date(b[sort]).getTime()) {
						return (parseFloat(a.id) < parseFloat(b.id))?	1	:	-1;;
					}

					return (new Date(a[sort]).getTime() < new Date(b[sort]).getTime())?	1	:	-1;
				}
				else {
					if(new Date(a[sort]).getTime() == new Date(b[sort]).getTime()) {
						return (parseFloat(a.id) < parseFloat(b.id))?	1	:	-1;;
					}

					return (new Date(a[sort]).getTime() < new Date(b[sort]).getTime())?	1	:	-1;
				}
			});

			if(articles.length == 0) {
				$("#MapsResult").hide();
				$("#List .nothing, #Maps .nothing").show();
			}

			let perPage	=	20;

			$(".pager").pagination(articles.length / perPage, {
				items_per_page	:	1,
				link_to			:	"javascript:;",
				prev_text		:	'<div class="link_before_pnt"><a class="link_before" href="#"></a></div>',
				next_text		:	'<div class="link_next_pnt"><a class="link_next" href="#"></a></div>',
				callback		:	function (index) {
					$("#ListResult > ul").stop().fadeOut(function () {
						$("#ListResult > ul").empty();

						for(article of articles.slice(index * perPage, (index + 1) * perPage)) {
							let template	=	$("#ListResult").attr("data-template");

							if(article.exterior) {
								template	=	template.replace("[image]", '<img class="lazy" data-src="'+ article.exterior +'">');
							}
							else {
								template	=	template.replace("[image]", '<img alt="" class="lazy" data-src="/upload/'+ article.developerID +'.jpg" class="fade_image">');
							}

							if((article.privilege +"").match(/^[0-9\.]+$/)) {
								template	=	template.replace("[privilege]", '<span class="btn red thin">社員特典</span><span class="font_red">販売価格の'+ article.privilege +'%割引</span>');
							}
							else if(article.privilege == "other" && article.privilegeOther) {
								template	=	template.replace("[privilege]", '<span class="btn red thin">社員特典</span><span class="font_red">'+ article.privilegeOther +'</span>');
							}
							else {
								template	=	template.replace("[privilege]", '');
							}

							if(article.access && article.access != "") {
								template	=	template.replace("[access]", article.access);
							}
							else {
								template	=	template.replace("[access]", article.groupName +" "+ article.lineName +" "+ article.stationName);
							}

							template	=	template.replace(/\[id\]/g, article.id);
							template	=	template.replace(/\[url\]/g, article.url);
							template	=	template.replace("[name]", article.name);
							template	=	template.replace("[address]", article.prefName + article.cityName + article.address);
							template	=	template.replace("[developerID]", article.developerID);
							template	=	template.replace("[developerName]", article.developerName);

							$("#ListResult ul").append(template);
						}

						$("#ListResult > ul").fadeIn();
						$("img.lazy").lazyload();
					});
				},
			});

			$("img.lazy").lazyload();
		}).trigger("change");

		if(first) {
			first	=	false;
		}
		else {
			$("html, body").stop().animate({scrollTop: $("#Maps, #List").filter(":visible").offset().top - $("header").height() - 15});
		}
	}

	//マップ
	function loadMap() {
		if(!InitMap) {
			setTimeout(function () {
				loadMap();
			}, 100);
			return;
		}

		Map	=	new google.maps.Map($("#MapsResult").get(0), {
			center	:	new google.maps.LatLng(35.658581, 139.745433),
			zoom	:	15,
		});
	}

	if($("#MapsResult").length != 0) {
		loadMap();
	}
});

//選択肢復元
$(window).on("popstate pageshow", function () {
	let results	=	{};

	new URLSearchParams(location.search).forEach(function (value, key) {
		key	=	key.replace("[]", "");

		if(!results[key]) {
			results[key]	=	[];
		}

		results[key].push(value);
	});

	$.each(results, function (key, value) {
		$("form [name="+ Common.escapeSelector(key) +"]").val(value[0]).trigger("change");

		if(key == "types") {
			let values	=	value;

			$("form.search input[name="+ Common.escapeSelector(key +"[]") +"]").prop("checked", false);

			for(value of values) {
				$("form.search input[name="+ Common.escapeSelector(key +"[]") +"][value="+ Common.escapeSelector(value) +"]").prop("checked", true).trigger("change");
			}
		}
		else {
			$("form.search select[name="+ Common.escapeSelector(key +"[]") +"]").val(value).trigger("change");
		}
	});

	if(location.href.indexOf("/map") != -1) {
		$("#List").fadeOut(function () {
			$("#Maps").fadeIn();
		});
	}
	else {
		$("#Maps").fadeOut(function () {
			$("#List").fadeIn();
		});
	}

	if(Object.keys(results).length != 0) {
		if(results["name"]) {
			$("#NameSearch").trigger("load");
		}
		else {
			$("#MainSearch").trigger("load");
		}
	}
});
